/* src/app/shared/category/category-detail/category-detail.component.css */
/*# sourceMappingURL=category-detail.component.css.map */
